// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2qVsQ","header":"PatientQuestionnaire_header__2tnY4","info":"PatientQuestionnaire_info__1m0u-"};